window.Products.Clothing.Shirt = function() {};
window.Products.Clothing.Shirt.inherits(window.Products.Clothing.Clothing);
window.Products.Clothing.Shirt.prototype.outsideObject = 2;
window.Products.Clothing.Shirt.prototype.insideObject = 0;
window.Products.Clothing.Shirt.prototype.position = -0.6;
window.Products.Clothing.Shirt.prototype.imageDataTexture = true;

window.Products.Clothing.Shirt.prototype.getObject = function(modelViewer, index) {
	if(!modelViewer.object) return;

	var children = modelViewer.object.children;
	while(children.length == 1 && children[0].children && !!children[0].children.length) children = children[0].children;
	return children[index];
};

window.Products.Clothing.Shirt.prototype.getObjectMaterial = function(object) {
	if(!object) return;

	if(object.material) {
		if(Array.isArray(object.material)) {
			for(var i = 0; i < object.material.length; i++) {
				if(object.material[i]) return object.material[i];
			}
			return;
		}

		return object.material;
	}

	if(!object.children) return;

	for(var j = 0; j < object.children.length; j++) {
		var material = this.getObjectMaterial(object.children[j]);
		if(material) return material;
	}
};

window.Products.Clothing.Shirt.prototype.setMaterialEnvMap = function(material) {
	if(!material || !this.envMap) return;

	material.envMap = this.envMap;
	material.envMap.mapping = THREE.EquirectangularReflectionMapping;
	material.needsUpdate = true;
	material.envMap.needsUpdate = true;
};

window.Products.Clothing.Shirt.prototype.set3dProperties = function(modelViewer) {
	var me = this;
	if(!me.texturesLoading && !me.texturesLoaded){
		me.loadTextures(function(){
			me.loadEnvMap(function(){
				if(modelViewer.die || !modelViewer.object) return;

				var oObject = me.getObject(modelViewer, me.outsideObject);
				var oMaterial = me.getObjectMaterial(oObject);

				if(!oMaterial) return;

				me.setMaterialEnvMap(oMaterial);
				me.updateThreeTexture(modelViewer);

				oMaterial.side = 0;

				if(typeof me.insideObject !== "undefined"){
					var iObject = me.getObject(modelViewer, me.insideObject);
					var iMaterial = me.getObjectMaterial(iObject);
					if(iMaterial) {
						iMaterial.side = 0;
						iMaterial.aoMapIntensity = 1.25;
					}
				}

				if(typeof me.detailsObject !== "undefined"){
					var dObject = me.getObject(modelViewer, me.detailsObject);
					var dMaterial = me.getObjectMaterial(dObject);
					if(dMaterial) {
						dMaterial.side = 0;
						me.setMaterialEnvMap(dMaterial);
					}
				}

				modelViewer.object.position.y = me.position;
				modelViewer.object.rotation.y = Math.PI;
				modelViewer.camera.position.y = 1;
			});
		});
	}
};

window.Products.Clothing.Shirt.prototype.loadTextures = function(callback){
	var product = this;
	var sources = [   
		'textures/noise.jpg',
		'textures/black_camo.jpg'
	];
	product.texturesLoading = true;
	product.texturesLoaded = 0;
	product.textures = [];
	sources.forEach(function(src, index) {
		var textureLoader = new THREE.TextureLoader();
		textureLoader.crossOrigin = 'anonymous';

		var texture = textureLoader.load(THREE_JSON_URL + src, function(event){
			product.textures[index] = event;
			product.texturesLoading = false;
			product.texturesLoaded++;
			if(callback && product.texturesLoaded == sources.length){
				callback();
			}
		});
	});
};

window.Products.Clothing.Shirt.prototype.getEditableOptions = function(){
	return ["color"];
};

window.Products.Clothing.Shirt.prototype.getEditableOptionsNames = function(){
	return [__("create_ns_option.color"), __("create_ns_option.decoration-method")];
};

window.Products.Clothing.Shirt.prototype.getCustomVariant = function(){
	//return this.getOptions()['decoration-method'];
	return 'dtg';
};

window.Products.Clothing.Shirt.prototype.getEditableOptionsExtra = function(_option, _container){
	var me = this;
	switch(_option) {
		case "color":
			return '';
		case "decoration-method":
			return '';
		default:
			return '';
	}
};

window.Products.Clothing.Shirt.prototype.getOptionsExtra = function(_option){
	var me = this;
	switch(_option) {
		case "color":
			return [];
		case "decoration-method":
			return [];
		default:
			return [];
	}
};

window.Products.Clothing.Shirt.prototype.handleOption = function(modelViewer, option, value){
	switch(option){
		case 'color':
			this.handleColorOption(modelViewer, value);
			break;
	}
};

window.Products.Clothing.Shirt.prototype.getOptions = function(){
	var editableOptions = this.getEditableOptions();
	var options = this.static.options;
	if(!options) return;

	var out = [];

	for(var option_type_slug in options){
		if(editableOptions.indexOf(option_type_slug) == -1) continue;

		switch(option_type_slug) {
			case 'color':
				out[option_type_slug] = $('#container_options_'+option_type_slug).find('input:checked').val();
				break;
			case 'decoration-method':
				out[option_type_slug] = $('#button_options_'+option_type_slug).attr('data-value');
				break;
		}
	}

	return out;
};

window.Products.Clothing.Shirt.prototype.initOptions = function(){
	$('#button_options_decoration-method').trigger('click');
};

window.Products.Clothing.Shirt.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.8;
	controls.maxDistance = 4.4;
};

window.Products.Clothing.Shirt.prototype.textureCanvasPrepass = function(ctx, scene, texture_resolution, options){
	var width = ctx.canvas.width, height = ctx.canvas.height;
	x = scene == "main" ? 0 : width/2;

	if(this.getColor) {
		var color, texture;
		if(options && options.color) {
			color = this.getColor(options.color);
			texture = this.getColorTexture ? this.getColorTexture(options.color) : null;
		} else {
			color = this.getColor($('#container_options_color').find('input:checked').attr('value'));
			texture = this.getColorTexture ? this.getColorTexture($('#container_options_color').find('input:checked').attr('value')) : null;
		}
		
		if(texture) {
			ctx.drawImage(this.textures[texture].image,0,0,width,height);
		} else {
			ctx.fillStyle = '#'+color.getHexString();
			ctx.fillRect(x/texture_resolution,0,width/texture_resolution/2,height/texture_resolution);
		}
	}
	ctx.fillRect(x/texture_resolution,0,width/texture_resolution/2,height/texture_resolution);
};

window.Products.Clothing.Shirt.prototype.textureCanvasPostpass = function(ctx, modelViewer, scene, texture_resolution, options){
	if(!this.static.extraCtxs) this.extraCtxs = [];
	
	// This might be called during a product change so exit if that's the case
	if(!modelViewer.object) return;

	var object = this.getObject(modelViewer, this.outsideObject);
	var material = this.getObjectMaterial(object);
	if(!material) return;

	var width = ctx.canvas.width, height = ctx.canvas.height;
	x = scene == "main" ? 0 : width/2;

	this.static.metalness = "#000";
	this.static.roughness = "#FFF";

	material.roughnessMap = null;
	material.metalnessMap = null;
	material.metalness = 0.009999999776482582; // Default metalness from gltf
	material.needsUpdate = true;

	if(this.getColor) {
		var color, texture;
		if(options && options.color) {
			color = this.getColor(options.color);
			texture = this.getColorTexture ? this.getColorTexture(options.color) : null;
		} else {
			color = this.getColor($('#container_options_color').find('input:checked').attr('value'));
			texture = this.getColorTexture ? this.getColorTexture($('#container_options_color').find('input:checked').attr('value')) : null;
		}
		
		if(texture) {
			ctx.drawImage(this.textures[texture].image,0,0,width,height);
		} else {
			ctx.fillStyle = '#'+color.getHexString();
			ctx.fillRect(x/texture_resolution,0,width/texture_resolution/2,height/texture_resolution);
		}
	}
};

window.Products.Clothing.Shirt.prototype.updateThreeTexture = function(modelViewer, options) {
	var object = this.getObject(modelViewer, this.outsideObject);
	var material = this.getObjectMaterial(object);
	if(!material) return;

	if(!modelViewer.inlab && modelViewer.textureImage){
		if(!modelViewer.lightCanvas && modelViewer.lightImage){
			modelViewer.lightCanvas = document.createElement('canvas'); 
			modelViewer.lightCanvas.width = 2048;
			modelViewer.lightCanvas.height = 2048;
			lightCtx = modelViewer.lightCanvas.getContext('2d');
			lightCtx.putImageData(modelViewer.lightImage, 0, 0);
			var lightTexture = new THREE.Texture(modelViewer.lightCanvas);
			lightTexture.flipY = false;
			lightTexture.needsUpdate = true;
			material.metalness = 1;
			material.metalnessMap = lightTexture;
			material.roughnessMap = lightTexture;
		}

		if(this.getColor) {
			ctx = modelViewer.texture.image.getContext("2d");
			var color;
			if(options?.color) {
				color = this.getColor(options.color);
			} else {
				color = this.getColor($('#productInfo-productOption-color').find('option:selected').attr('data-slug'));
			}
			ctx.putImageData(modelViewer.textureImage, 0, 0);
			ctx.globalCompositeOperation = 'destination-over';
			ctx.fillStyle = '#'+color.getHexString();
			ctx.fillRect(0,0,2048,2048);
			ctx.globalCompositeOperation = 'source-over';
		}
	}

	if(modelViewer.texture) {
		material.map = modelViewer.texture;
		material.map.flipY = false;
		material.map.needsUpdate = true;
	}
	material.needsUpdate = true;
};

window.Products.Clothing.Shirt.prototype.getPageFitDimensions = function(variant, scene){
	var data = this.static.preview_data.scenes[scene];
	var width = data.originalWidth;
	var height = data.originalHeight;
	return [width, height];
};

window.Products.Clothing.Shirt.prototype.getSceneScale = function(_from, _to){
	return 1;
};

window.Products.Clothing.Shirt.prototype.getDecorationMethodModal = function(){
	var me = this;
	var options = this.static.options;
	var option = null;
	var option_slug = null;

	for(var option_type_slug in options){
		if(!options.hasOwnProperty(option_type_slug)) continue;
		if(option_type_slug != "decoration-method") continue;
		option_slug = option_type_slug;
		option = options[option_type_slug];
	}

	var $modal = $('<div class="modal small dark-mode"><div class="modal-content"><h3>'+option.name+'</h3></div></div>');

	var onClick = function(e) {
		e.data.option = option_slug;
		me.handleOption(e);
		$modal.modal('close');
	};

	for(var option_value_slug in option.values){
		if(!option.values.hasOwnProperty(option_value_slug)) continue;
		var value = option.values[option_value_slug];
		var $thumb = $('<input type="radio" id="input_' + value.slug + '" name="option_' + option_slug + '" value="' + value.slug + '">');
		var $row = $(
			'<div class="row waves-effect waves-light" style="display:block">'+
				'<div class="col s12">'+
					'<div class="col s3">'+
						'<img src="'+this.getOptionThumb(value.slug)+'">'+
					'</div>'+
					'<div class="col s9">'+
						'<h4>'+__("create_ns_option.decoration-method.option-"+value.slug+"-name")+'</h4>'+
						__("create_ns_option.decoration-method.option-"+value.slug+"-description")+
					'</div>'+
				'</div>'+
			'</div>'
		);
		$row.append($thumb);
		$row.on('click', {
			value: value
		}, onClick);
		$($row).appendTo($modal.find('.modal-content'));
	}

	return $modal;
};

window.Products.Clothing.Shirt.prototype.setThreeView = function(camera, view, zoom) {
	if(!zoom) zoom = 0;
	this.parent.parent.setThreeView(camera, view, zoom * -1);
};
